// src/components/Footer/Footer.js

import React, { useState } from 'react';
import ULogo from '../../assets/ulogo.svg';
import XLogo from '../../assets/xlogo.svg';
import DLogo from '../../assets/dlogo.svg';
import DexLogo from '../../assets/dexlogo.png'; 
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '../../App.css';
import { CASHISDEAD_ADDRESS, NETWORK_CONFIG } from '../../contracts/constants';

const Footer = () => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  return (
    <footer className="App-footer">
      <div className="footer-content">
        
        <Typography variant="caption" color="white" sx={{ mt: 0.5 }}>
          CA on Unichain: {CASHISDEAD_ADDRESS}
        </Typography>
        <Typography variant="caption" color="white" sx={{ mt: 0.5 }}>
          CA on Solana: ELwD4G5j9s7mktzrA9vN3nfFbZE56J3vUhgjoHRwpump
        </Typography>

        <div className="social-buttons">
          <a
            href="https://unichain.org"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button"
            aria-label="Visit Unichain"
          >
            <img src={ULogo} alt="Unichain Logo" className="social-logo" />
          </a>
          <a
            href={`${NETWORK_CONFIG.blockExplorer}/token/${CASHISDEAD_ADDRESS}`}
            target="_blank"
            rel="noopener noreferrer"
            className="social-button"
            aria-label="View on Explorer"
          >
            <img src={DLogo} alt="Dextools Logo" className="social-logo" />
          </a>
          <a
            href="https://x.com/_CASHisDEAD_"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button"
            aria-label="Follow us on X"
          >
            <img src={XLogo} alt="Follow us on X" className="social-logo" />
          </a>
          <a
            href="https://dexscreener.com/unichain"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button"
            aria-label="View on DexScreener"
          >
            <img src={DexLogo} alt="DexScreener Logo" className="social-logo" />
          </a>
        </div>

        <button onClick={handleOpenModal} className="terms-button">
          Terms
        </button>
      </div>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="terms-modal-title"
      >
        <Box className="terms-modal">
          
          <Box className="terms-modal-header">
            <Typography
              variant="h6"
              id="terms-modal-title"
              sx={{ fontWeight: 'bold' }}
            >
              $CASH DAO Terms & Conditions
            </Typography>
            <IconButton
              onClick={handleCloseModal}
              aria-label="Close Modal"
              className="close-modal-button"
            >
              &times;
            </IconButton>
          </Box>

          <Accordion disableGutters className="terms-accordion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: 'var(--primary-color)' }} />}
            >
              <Typography variant="subtitle1" fontWeight="bold">Bylaws</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Mission:</strong> To reduce traditional control mechanisms, paving the path to an economy without boundaries.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Vision:</strong> A borderless system of exchange for all, unifying growth through community efforts for all.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Values:</strong> Courage, autonomy, and inventive spirit. We stand for freedom, self-power, and synergy, forging new possibilities for all.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Governance:</strong> Community-driven governance by $CASH holders, collectively steering our course toward independence and shared achievement.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Divider sx={{ my: 1, backgroundColor: 'var(--primary-color)' }} />

          <Accordion disableGutters className="terms-accordion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: 'var(--primary-color)' }} />}
            >
              <Typography variant="subtitle1" fontWeight="bold">Terms of Service</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>User Responsibility:</strong> Users must understand and abide by any relevant laws for compliance in their own regions.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>No Guarantees:</strong> We make no promises about value or success. Participation is a personal choice, taken at your own risk.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Autonomy:</strong> CASH DAO is self-sustaining and community-led. Once live, its evolution reflects collective ambitions.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Divider sx={{ my: 1, backgroundColor: 'var(--primary-color)' }} />

          <Accordion disableGutters className="terms-accordion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: 'var(--primary-color)' }} />}
            >
              <Typography variant="subtitle1" fontWeight="bold">Privacy Policy</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Data Collection:</strong> We do not maintain personal records. The blockchain alone tracks actions and ownership.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Security:</strong> We encourage secure wallet practices and staying vigilant against threats. Your safety is your responsibility.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Third-Party Links:</strong> External sites are referenced for convenience; we neither endorse nor control outside content.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Modal>
    </footer>
  );
};

export default Footer;